import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await auth.post("/auth/google/exchange", { session_id });
        toast.success(`WELCOME · ${data.name || data.email}`);
        // clear the fragment then go to dashboard
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        toast.error("GOOGLE_AUTH_FAILED", {
          description: e?.response?.data?.detail || e?.message || "",
        });
        nav("/login", { replace: true });
      }
    })();
  }, [nav]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-zinc-400 font-mono text-[12px] flex items-center justify-center">
      EXCHANGING_GOOGLE_SESSION…
    </div>
  );
}
